const getArrWithAvaliable = (baseLine, avaList) => {
  let arrWithAvaliableState = [];

  baseLine.forEach(item => {
    var status = "notAvailable";
    var cbu = "";
    var cci = "";

    for (var i = 0; i < avaList.length; i++) {
      if (avaList[i].code === item.code) {
        if (avaList[i].hasOwnProperty("id")) {
          //第2層如果有id
          if (avaList[i].id.stockAvailable) {
            //有選項, 有庫存, 顯示;
            status = "available";
            cbu = avaList[i].id.cbu;
            cci = avaList[i].id.cci;
            break; //可能有好幾個相同的code 項目，找到其中任何一個有庫存就表示有庫存，跳出來不用再找。
          } else {
            //有選項, 沒庫存, 灰色
            status = "outOfStock"; //遍歷整個陣列，是否全部都沒庫存。
          }
        } else {
          //第2層沒有id
          status = "available";
        }
      }
    }

    arrWithAvaliableState.push({
      code: item.code,
      name: item.name,
      status: status,
      cbu: cbu,
      cci: cci
    });
  });

  return arrWithAvaliableState;
};

export default getArrWithAvaliable;
